"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUserPrivate = void 0;
const affiliate_1 = require("./affiliate");
const ambassador_1 = require("./ambassador");
function mockUserPrivate(overrides = {}) {
    return {
        admin: false,
        affiliate: (0, affiliate_1.mockAffiliate)(),
        ambassador: false,
        book_guide_url: null,
        brands: [],
        cart_id: 'gid://shopify/Cart/Z2NwLXVzLWNlbnRyYWwxOjAxSkU0M0VGNEtUM0Q5Sk0yNFQ5MkVIOTBK?key=371cf6e4272aa1348e56be799c7b3b3c',
        checkout_id: 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC82MWFmMzhlNWE2MGUyNDYwZGFkN2E3NjgwMmU5M2FjZj9rZXk9MTE2ZTJmYjg2N2YwNTA3ZGFjMzIxZWQ1MTU5ZjY4NWI=',
        description: null,
        email: 'user@example.com',
        experiment_group_id: 420,
        experiment_uuid: 'b8cccf0b-74d6-4755-82ba-ae644af6ceee',
        facebook: null,
        instagram: null,
        location: null,
        map_temperature_activated: false,
        organizations: [],
        premium_expires_at: null,
        premium_ordered_at: null,
        premium_pro_demo_complete: false,
        premium_pro_expires_at: null,
        premium_pro_ordered_at: null,
        premium_pro: false,
        premium: false,
        role: 'standard',
        slug: null,
        species: [],
        tiktok: null,
        title: null,
        twitter: null,
        user: (0, ambassador_1.mockAmbassadorMini)(),
        verified: true,
        website: null,
        wishlist_hash: 'Jfei2na',
        youtube_title: null,
        youtube: null,
        zone_id: 3,
        ...(0, ambassador_1.mockAmbassadorMini)(),
        ...overrides,
    };
}
exports.mockUserPrivate = mockUserPrivate;
